export default __webpack_public_path__ + "static/media/b-3.f3e9c0bd.png";